// The New Invoice page's matter filter (migration 0061): every unbilled item
// on the project, one matter's, or only what belongs to none.

export type MatterFilter = 'all' | 'none' | number;

/** Whether an item on matter `matterId` (null = none) passes `filter`. */
export function matterFilterMatches(filter: MatterFilter, matterId: number | null | undefined): boolean {
  if (filter === 'all') return true;
  if (filter === 'none') return matterId == null;
  return matterId === filter;
}
